import type {
  AnswerInquiryDto,
  CreateInquiryDto,
  InquiryCategory,
  InquiryProduct,
  InquiryWithUser,
} from "dutyon-server/types";
import { httpClient } from "./httpClient";

export type { InquiryWithUser } from "dutyon-server/types";

export const createInquiry = async (data: CreateInquiryDto): Promise<InquiryWithUser> => {
  const response = await httpClient.post<InquiryWithUser>("/inquiries", data);
  return response.data;
};

export const getInquiries = async ({
  page,
  limit,
  status,
  product,
  category,
}: {
  page?: number;
  limit?: number;
  status?: string;
  product?: InquiryProduct;
  category?: InquiryCategory;
} = {}): Promise<{ list: InquiryWithUser[]; total: number }> => {
  const params = new URLSearchParams();
  if (page) params.append("page", page.toString());
  if (limit) params.append("limit", limit.toString());
  if (status) params.append("status", status);
  if (product) params.append("product", product);
  if (category) params.append("category", category);

  const query = params.toString() ? `?${params.toString()}` : "";
  const response = await httpClient.get<{ list: InquiryWithUser[]; total: number }>(
    `/inquiries${query}`,
  );
  return response.data;
};

export const getInquiry = async (id: string): Promise<InquiryWithUser> => {
  const response = await httpClient.get<InquiryWithUser>(`/inquiries/${id}`);
  return response.data;
};

export const answerInquiry = async (
  id: string,
  data: AnswerInquiryDto,
): Promise<InquiryWithUser> => {
  const response = await httpClient.post<InquiryWithUser>(`/inquiries/${id}/answer`, data);
  return response.data;
};
